import React, { useState } from 'react';
import { Button } from 'antd';
import { Package } from 'lucide-react';
import QuickPkgForm from './QuickPkgForm'; // Adjust import path as needed

interface QuickPkgButtonProps {
  onSuccess?: () => void;
  className?: string;
}

const QuickPkgButton: React.FC<QuickPkgButtonProps> = ({ onSuccess, className }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSuccess = () => {
    onSuccess?.();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        type="primary"
        icon={<Package size={16} />}
        onClick={() => setIsModalOpen(true)}
        className={className}
      >
        Quick Pkg
      </Button>
      
      <QuickPkgForm
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default QuickPkgButton;